import React, { PureComponent } from 'react'
import Overlay from 'views/overlay/overlay'
import { connect } from 'react-redux'
import { localize } from 'helpers/translator'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import privateLibraryActions from 'redux/actions/privateLibraryActions'
import { privateLibrarySelectors } from 'redux/selectors'

class DistrictLibraryOnboardingOverlay extends PureComponent {

	componentDidMount() {
		this.props.actions.overlayDistrictLibraryOnboardingInitialize()
	}

	onButtonConfirm = () => {
		this.props.actions.overlayDistrictLibraryOnboardingConfirm()
	}

	render() {
		const buttonOne = {text: localize('admin_onboarding_express_gotit_thanks'), action: this.onButtonConfirm}

		return <Overlay
			offerTitle={localize('district_library_onboarding_overlay_title')}
			offerMessage={localize('district_library_onboarding_overlay_body')}
			buttonOne={buttonOne}
			videoIcon={this.props.icon} />
	}
}

function mapStateToProps(state) {
	return privateLibrarySelectors.getDistrictOverlayData(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		overlayDistrictLibraryOnboardingInitialize: privateLibraryActions.overlayDistrictLibraryOnboardingInitialize,
		overlayDistrictLibraryOnboardingConfirm: privateLibraryActions.overlayDistrictLibraryOnboardingConfirm,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DistrictLibraryOnboardingOverlay)
